import React, { useState, useEffect } from 'react'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { useDispatch, useSelector } from 'react-redux';
import { modalAction, modalDeleteAction } from '../../redux/reducers/Modal';
import SuccessModal from '../SuccessModal';
import DangerModal from '../DangerModal';
import { Pagination, PaginationItem, Grid } from '@mui/material';
import styled from '@mui/material/styles/styled';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import moment from 'moment';
import 'moment/locale/es';

const PaginationGrid = styled(Grid)(({ theme }) => `
    ul{
        justify-content: end
    }

    button:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)

const PaginationItemStyled = styled(PaginationItem)(({ theme }) => `
    svg{
        color: #000;
    }

    button:hover, svg:hover{
        background: ${theme.palette.primary.light};
        color: #FFF
    }
`)


function createData(id, room, mount, service, total, checkIn, checkOut) {
  return { id, room, mount, service, total, checkIn, checkOut };
}

const rows = [
  createData('010', 'Suite', 80, 25, 105, moment().format('DD/MM/YYYY HH:mm:ss'), moment().format('DD/MM/YYYY HH:mm:ss')),
  createData('007', 'Junior Suite', 60, 0, 60, moment().format('DD/MM/YYYY HH:mm:ss'), moment().format('DD/MM/YYYY HH:mm:ss')),
];


const DailyReport = () => {

    const [ clients, setClients ] = useState([]);
    const [ paginations, setPaginations ] = useState(0);
    const [ initResult, setInitResult ] = useState(0);
    const [ endResult, setEndResult ] = useState(10);
    const [ totalProductPrice, setTotalProductPrice ] = useState(0);
    const searchData = useSelector( state => state.Search.data );

    const [page, setPage] = React.useState(1);
    const handleChange = (event, value) => {
        if( page < value ){
            // aumentar
            setInitResult(initResult+10);
            setEndResult(endResult+10);
        }else{
            // disminuir
            setInitResult(initResult-10);
            setEndResult(endResult-10);
        }
        setPage(value);
    };

    useEffect( () => {
        setClients(rows);

        setPaginations(Math.ceil(rows.length/10))
    },[searchData, initResult, endResult] );

    const dispatch = useDispatch();
    const [ showModal, setShowModal ] = useState(false);
    const [ showDeleteModal, setShowDeleteModal ] = useState(false);
    const [ modalForm, setModalForm ] = useState('');
    const [ deleteModal, setDeleteModal ] = useState('');
    const modalStatus = useSelector( state => state.Modal.modalState );
    const deleteModalStatus = useSelector( state => state.Modal.deleteModalState );

    useEffect( () => {
        setShowModal(modalStatus);
      }, [modalStatus] );
    
    useEffect( () => {
        setShowDeleteModal(deleteModalStatus);
      }, [deleteModalStatus] );

    useEffect( () => {
        let price = 0;
        rows.map( product => {
            price = price + product.total;
            setTotalProductPrice(price);
        } )
    },[] );

    const editClient = () => {
        setDeleteModal('');
        dispatch(modalAction());
        setModalForm('editClient');
    }

    const deleteClient = () => {
        setModalForm('');
        dispatch(modalDeleteAction());
        setDeleteModal('client');
    }

  return (
    <>
        {
            (showModal && modalForm !== '' ) &&
            <SuccessModal view={modalForm} />
        }
        {
            (showDeleteModal && deleteModal !== '' ) &&
            <DangerModal view={deleteModal} />
        }
        <TableContainer component={Paper}>
            <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>Habitación</TableCell>
                    <TableCell>Dinero dejado</TableCell>
                    <TableCell>Servicio</TableCell>
                    <TableCell>Total</TableCell>
                    <TableCell>Hora de ingreso</TableCell>
                    <TableCell>Hora de salida</TableCell>
                </TableRow>
                </TableHead>
                <TableBody>
                {clients.map((row) => (
                    <TableRow
                    key={row.id}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">{row.id.substring(0, 5)}</TableCell>
                      <TableCell>{row.room}</TableCell>
                      <TableCell>{row.mount}</TableCell>
                      <TableCell>{row.service}</TableCell>
                      <TableCell>{row.total}</TableCell>
                      <TableCell>{row.checkIn}</TableCell>
                      <TableCell>{row.checkOut}</TableCell>
                    </TableRow>
                ))}
                    <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }} >
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                        <TableCell>Total: ${totalProductPrice}</TableCell>
                        <TableCell></TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

        <Grid container sx={{ justifyContent: 'end', textAlign: 'end', mt: 2 }}>
            <PaginationGrid item xs={12}>
                <Pagination
                    count={paginations}
                    onChange={handleChange}
                    renderItem={(item) => (
                        <PaginationItemStyled
                        components={{ previous: ArrowBackIcon, next: ArrowForwardIcon }}
                        {...item}
                        />
                    )}
                />
            </PaginationGrid>
        </Grid>
    </>
  )
}

export default DailyReport